export const createUniqueUsers = (assignmentGroups, teamFilter) => {
    return assignmentGroups
        .filter((assignmentGroup) => {
            return teamFilter ? assignmentGroup.assignmentGroupKey === teamFilter : assignmentGroup;
        })
        .reduce((userAssignmentGroups, { users }) => {
            return userAssignmentGroups.concat(users);
        }, [])
        .map(({ userId, fullName }) => {
            return {
                text: fullName,
                value: userId,
            };
        })
        .filter((user, index, allUsers) => {
            return index === allUsers.findIndex(({ value }) => value === user.value);
        })
        .sort((a, b) => a.text.localeCompare(b.text));
};
